import api from '../../api/apiService';
import { CreatePreferenceDto, PreferenceDto, UpdatePreferenceDto } from '../../models/Preference';
import { getCurrentUser } from '../auth';

export const preferencesUri = (userId: string): string => `/profile/v1/profiles/${userId}/preferences`;

export const fetchPreferences = async (): Promise<PreferenceDto<unknown>[]> => {
  const { userId } = getCurrentUser();
  if (!userId) {
    return Promise.reject(new Error('Failed to get userId'));
  }

  const { data } = await api.get<PreferenceDto<unknown>[]>(preferencesUri(userId));
  return data || [];
};

export const fetchPreference = async <T>(id: string): Promise<PreferenceDto<T>> => {
  const { userId } = getCurrentUser();
  if (!userId) {
    return Promise.reject(new Error('Failed to get userId'));
  }

  const { data } = await api.get<PreferenceDto<T>>(`${preferencesUri(userId)}/${id}`);
  return data;
};

export const fetchPreferenceByKey = async <T>(key: string): Promise<PreferenceDto<T>> => {
  const { userId } = getCurrentUser();
  if (!userId) {
    return Promise.reject(new Error('Failed to get userId'));
  }

  const { data } = await api.get<PreferenceDto<T>>(`${preferencesUri(userId)}/by-key/${key}`);
  return data;
};

export const createPreference = async <T>(preference: CreatePreferenceDto<T>): Promise<PreferenceDto<T>> => {
  const { userId } = getCurrentUser();
  if (!userId) {
    return Promise.reject(new Error('Failed to get userId'));
  }

  const { data } = await api.post<PreferenceDto<T>>(preferencesUri(userId), preference);
  return data;
};

export const updatePreference = async <T>(
  id: string,
  preference: UpdatePreferenceDto<T>
): Promise<PreferenceDto<T>> => {
  const { userId } = getCurrentUser();
  if (!userId) {
    return Promise.reject(new Error('Failed to get userId'));
  }

  const { data } = await api.patch<PreferenceDto<T>>(`${preferencesUri(userId)}/${id}`, preference);
  return data;
};

export const updatePreferenceByKey = async <T>(
  key: string,
  preference: UpdatePreferenceDto<T>
): Promise<PreferenceDto<T>> => {
  const { userId } = getCurrentUser();
  if (!userId) {
    return Promise.reject(new Error('Failed to get userId'));
  }

  const { data } = await api.patch<PreferenceDto<T>>(`${preferencesUri(userId)}/by-key/${key}`, preference);
  return data;
};
